export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/chat": [10,[2]],
		"/chat/[chat]": [11,[2]],
		"/home": [12],
		"/join": [13],
		"/people": [14],
		"/people/[npub]": [15,[3]],
		"/settings/about": [16,[4]],
		"/settings/alerts": [17,[4]],
		"/settings/content": [18,[4]],
		"/settings/hosting": [19,[4]],
		"/settings/privacy": [20,[4]],
		"/settings/profile": [21,[4]],
		"/settings/relays": [22,[4]],
		"/settings/theme": [23,[4]],
		"/settings/wallet": [24,[4]],
		"/share": [25],
		"/spaces": [26,[5]],
		"/spaces/create": [47,[5]],
		"/spaces/[relay]": [27,[5,6]],
		"/spaces/[relay]/about": [29,[5,6]],
		"/spaces/[relay]/admin": [30,[5,6]],
		"/spaces/[relay]/articles": [31,[5,6]],
		"/spaces/[relay]/articles/[address]": [32,[5,6]],
		"/spaces/[relay]/calendar": [33,[5,6]],
		"/spaces/[relay]/calendar/[address]": [34,[5,6]],
		"/spaces/[relay]/chat": [35,[5,6]],
		"/spaces/[relay]/classifieds": [36,[5,6]],
		"/spaces/[relay]/classifieds/[address]": [37,[5,6]],
		"/spaces/[relay]/directory": [38,[5,6]],
		"/spaces/[relay]/goals": [39,[5,6]],
		"/spaces/[relay]/goals/[id]": [40,[5,6]],
		"/spaces/[relay]/library": [41,[5,6]],
		"/spaces/[relay]/polls": [42,[5,6]],
		"/spaces/[relay]/polls/[id]": [43,[5,6]],
		"/spaces/[relay]/recent": [44,[5,6]],
		"/spaces/[relay]/threads": [45,[5,6]],
		"/spaces/[relay]/threads/[id]": [46,[5,6]],
		"/spaces/[relay]/[h]": [28,[5,6,7]],
		"/[bech32]": [9]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';